#import "./VariantFragment.gql"

query ProductBySkuQuery($query: String!, $lang: LanguageCode!) @inContext(language: $lang) {
  products(first: 1, query: $query) {
    edges {
      node {
        id
        handle
        title
        productType
        variants(first: 99) {
          edges {
            node {
              ...VariantFragment
            }
          }
        }
      }
    }
  }
}
